const StoreNameURL = (response) => {
  return response
    .replace(/[^\w\s]/gi, '')
    .toLowerCase()
    .replace(/\s+/g, '-');
};
const storeLocatorText = '/store-locator/';

export default { StoreNameURL, storeLocatorText };
